<a routerLink="/">
  <img
    alt="Republic Services logo"
    width="128"
    src="/assets/rs-logo-with-text.svg"
  />
</a>
